<template>
  <v-card flat>
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-toolbar dense flat dark color="primary">
              <v-toolbar-title>
                <span class></span>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <div>Scheduled Report Name</div>
              <p class="text-h4 text--primary">{{datasourceMailerAttachment.name}}</p>
              <template v-for="colName in colNames">
                <div :key="colName">
                  <p class="text--primary"><strong>{{fieldName(colName) | capitalize}}: </strong>{{fieldValue(colName, datasourceMailerAttachment)}}</p>
                </div>
              </template>
              <v-btn @click="doDownloadAttachment" color="primary" dark>Download</v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { useDatasourceMailerCrud } from './crudComposable'
import { DateTime } from 'luxon'
const { split, path } = require('ramda')

export default {
  name: 'show-datasource-mailer',
  setup () {
    const { datasourceMailerAttachment, fetchAttachment, downloadAttachment } = useDatasourceMailerCrud()
    return {
      datasourceMailerAttachment,
      fetchAttachment,
      downloadAttachment
    }
  },
  data () {
    return {
      colNames: [
        'name',
        'content_type',
        'created_at',
        'meta.total_record_count',
        'meta.total_email_count',
        'meta.total_address_count'
      ]
    }
  },
  methods: {
    fieldValue (field) {
      const fieldVal = path(split('.', field), this.datasourceMailerAttachment)
      if (field.endsWith('_at')) {
        return fieldVal ? DateTime.fromISO(fieldVal).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS) : ''
      } else {
        return fieldVal
      }
    },
    fieldName (field) {
      return field.replace(/\./gi, ' ').replace(/_/gi, ' ')
    },
    doDownloadAttachment () {
      this.downloadAttachment(this.$route.params.datasource_mailer_id, this.$route.params.id)
    }
  },
  mounted () {
    this.fetchAttachment(this.$route.params.datasource_mailer_id, this.$route.params.id)
  }

}
</script>
